const Vision = () => {
  return (
    <div className="vision">
      <div className="vision-title">OUR VISION</div>
      <div className="vision-dec">
        ABM provides professional property management while always putting the
        needs of the community first. Exceptional customer care is at the heart
        of our work. We see ourselves not just as a management company, but as a
        trusted partner for the communities we serve. By working alongside the
        Association's Board of Directors, we help safeguard the value and
        integrity of the homes and neighborhoods we care for—bringing us immense
        pride and fulfillment in the work we do.
      </div>
      <button className="btn btn-primary vision-btn" onClick={() => {
        window.open('https://portal.abmpropertymgmt.com/login', '_blank');
      }}>Learn More</button>
    </div>
  );
};

export default Vision;
